import { useNavigate, useLocation } from "react-router-dom";
import { NAV_LINKS } from "@/data/content";
import Icon from "@/components/Icon";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handle = (l) => {
    if (l.type === "route") return navigate(l.target);
    if (location.pathname !== "/") navigate("/", { state: { scrollTo: l.target } });
    else {
      const el = document.getElementById(l.target);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <footer className="footer" data-testid="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <img src="/assets/logo-ums-footer.png" alt="Proactive UMS+" />
        </div>
        <nav className="footer__links">
          {NAV_LINKS.map((l) => (
            <button key={l.label} onClick={() => handle(l)} className="footer__link">{l.label}</button>
          ))}
        </nav>
        <div className="footer__social-wrap">
          <p className="footer__tagline">Building a healthier, more connected world.</p>
          <div className="footer__social">
            <a href="#" aria-label="LinkedIn"><Icon name="Linkedin" size={16} /></a>
            <a href="#" aria-label="YouTube"><Icon name="Youtube" size={16} /></a>
            <a href="#" aria-label="X"><Icon name="Twitter" size={16} /></a>
            <a href="#" aria-label="Instagram"><Icon name="Instagram" size={16} /></a>
          </div>
        </div>
      </div>
      <div className="footer__bar">
        <div className="container footer__bar-inner">
          <span>© 2024 Proactive UMS Corporate. All rights reserved.</span>
          <span className="footer__slogan">People. Technology. Better Tomorrows.™ · <a href="/admin/login" className="footer__admin" data-testid="footer-admin-link">Staff Login</a></span>
        </div>
      </div>
    </footer>
  );
}
